import styled from 'styled-components';
import Image from '../../../assets/SurgicalMeshImage.png'

const ImageContainer = styled.div`
    width: 90%;
    margin: auto;
    margin-top: 48px;

    img {
        width: 400px;
        
        @media (max-width: 1000px) {
            width: 375px;
        }
        @media (max-width: 800px) {
            width: 325px;
        }
        @media (max-width: 500px) {
            width: 300px;
        }
    }
`;

const  SurgicalMeshImage = () => {
    return <ImageContainer>
        <img src={Image} />
    </ImageContainer>
}

export default SurgicalMeshImage;